import { TreeView } from "devextreme-react";
import React, { useState } from "react";


const data = [
  { id: "Today", text: "Today", isCheckable: true, type: "period" },
  { id: "Last 5 min", text: "Last 5 min", isCheckable: true, type: "period" },
  { id: "Last 20 min", text: "Last 20 min", isCheckable: true, type: "period" },
  { id: "Last 1 hour", text: "Last 1 hour", isCheckable: true, type: "period" },
  { id: "Last 4 hour", text: "Last 4 hour", isCheckable: true, type: "period" },
  { id: "Last 12 hour", text: "Last 12 hour", isCheckable: true, type: "period" },
  { id: "Last 24 hour", text: "Last 24 hour", isCheckable: true, type: "period" },
  { id: "Yesterday", text: "Yesterday", isCheckable: true, type: "period" },
  { id: "This Week", text: "This Week", isCheckable: true, type: "period" },
  { id: "This Month", text: "This Month", isCheckable: true, type: "period" },
  { id: "Last Month", text: "Last Month", isCheckable: true, type: "period" },
  { id: "Last 7 days", text: "Last 7 days", isCheckable: true, type: "period" },
  { id: "Custom", text: "Custom", isCheckable: true, type: "period" },
]


const PeriodFilter = () => {

  const [selectedPeriod, setSelectedPeriod] = useState(null);


  const handlePeriodCheck = (value) => {
    setSelectedPeriod(value);
    handleValueChange(value); // reuse your existing logic
  };

  const handleValueChange = async (value) => {
    // your big switch/case logic from before
  };

  const renderItem = (item) => {
    if (item.isCheckable) {
      if (item.type === "period") {
        return (
          <label style={{ cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={selectedPeriod === item.id}
              onChange={() => handlePeriodCheck(item.id)}
              style={{ marginRight: "6px" }}
            />
            {item.text}
          </label>
        );
      }
    }

    return <span>{item.text}</span>;
  };


  return(
    <>
    <TreeView
      items={data}
      expandNodesRecursive={true}
      width="100%"
      itemRender={renderItem}
    />
    </>
  ) 
}

export default PeriodFilter;